import React, { CSSProperties } from "react"
import { FontIcon } from "material-ui"
import moment from "moment"
import { blueGrey500 } from "material-ui/styles/colors"
import strings from "../../localization/strings"
import { IDate, EDayOfWeek } from "../../models"
import FinddDatePicker from "./FinddDatePicker"
import BackspaceIcon from "material-ui/svg-icons/content/backspace"

interface IProps {
    // startOfDay and endOfDay should not set at same time
    startOfDay?: boolean
    endOfDay?: boolean
    readonly?: boolean
    label: string
    style?: CSSProperties
    errorText?: string
    date: IDate
    firstDayOfWeek?: EDayOfWeek
    minDate?: IDate
    maxDate?: IDate
    width?: number
    iconStyle?: CSSProperties
    datePickerStyle?: CSSProperties
    textFieldStyle?: CSSProperties
    optional?: boolean
    formatDate?(date): any
    handleSelectDate(date: IDate): void
}

export default class IconDatePicker extends React.Component<IProps, {}> {
    private FinddDatePicker
    render() {
        const showBackspaceIcon = !this.props.readonly && this.props.optional
        return (
            <div style={{ ...this.props.style, position: "relative", display: "inline-block" }}>
                <FinddDatePicker
                    data-intercom-target={`Select-${this.props.label}`}
                    name="IconDatePicker"
                    ref={elem => this.FinddDatePicker = elem}
                    style={{ width: this.props.width ? this.props.width : null, ...this.props.datePickerStyle }}
                    dialogContainerStyle={{ zIndex: 3000 }}
                    floatingLabelText={this.props.label}
                    floatingLabelStyle={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", width: "100%" }}
                    formatDate={date => this.props.formatDate ? this.props.formatDate(date) : moment(date).format("MM/DD/YYYY")}
                    onChange={(e, date) =>
                        this.props.handleSelectDate(
                            this.props.startOfDay ?
                                moment(date).startOf("day").format() :
                                this.props.endOfDay ?
                                    moment(date).endOf("day").format() :
                                    moment(date).format()
                        )
                    }
                    disabled={this.props.readonly}
                    value={this.props.date ? moment(this.props.date).toDate() : null}
                    errorText={this.props.errorText}
                    errorStyle={{ position: "absolute", top: 68 }}
                    textFieldStyle={{ width: "170px !important", ...this.props.textFieldStyle }}
                    cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
                    firstDayOfWeek={0}
                    maxDate={this.props.maxDate && moment(this.props.maxDate).toDate()}
                    minDate={this.props.minDate && moment(this.props.minDate).toDate()}
                />
                <FontIcon
                    data-intercom-target={"OpenDatePicker"}
                    className="fa fa-calendar"
                    style={{ position: "absolute", top: 35, right: showBackspaceIcon ? 30 : 5, fontSize: 21, color: "rgba(97, 97, 97, 0.6)", ...this.props.iconStyle }}
                    onClick={() => !this.props.readonly && this.FinddDatePicker.DatePicker.openDialog()}
                />
                {showBackspaceIcon &&
                    <BackspaceIcon
                        style={{ position: "absolute", top: 36, right: 5, width: 20, height: 20, color: "rgba(97, 97, 97, 0.6)" }}
                        onClick={e => {
                            e.stopPropagation()
                            this.props.handleSelectDate(null)
                        }}
                    />
                }
            </div>
        )
    }
}